import { createContext } from 'react';

const ContentContext = createContext(null);

export { ContentContext };
